import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.75,
			cy: 9,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.25,
			cy: 9,
			r: 1.5,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
